import { useState } from "react";

import { Chip } from "@/components/Chip";
import { SignalCard } from "@/components/SignalCard";
import { Centered, Spinner } from "@/components/Spinner";
import { api } from "@/lib/api";
import { AUTO_REFRESH_MS } from "@/lib/config";
import { usePublishRefresh } from "@/lib/refresh";
import type { Direction } from "@/lib/types";
import { useFetch } from "@/lib/useFetch";

const FILTERS: { key: "all" | Direction; label: string }[] = [
  { key: "all", label: "전체" },
  { key: "buy", label: "매수" },
  { key: "sell", label: "매도" },
  { key: "hold", label: "보류" },
];

export function SignalsScreen() {
  const [filter, setFilter] = useState<"all" | Direction>("all");

  const state = useFetch(
    (signal) => api.listSignals(filter === "all" ? undefined : filter, signal),
    [filter],
    { revalidateOnFocus: true, intervalMs: AUTO_REFRESH_MS },
  );
  usePublishRefresh({
    refresh: state.refresh,
    refreshing: state.refreshing,
    updatedAt: state.updatedAt,
  });

  const signals = state.data?.data ?? [];

  return (
    <>
      <div className="filters">
        {FILTERS.map((f) => (
          <Chip
            key={f.key}
            label={f.label}
            active={filter === f.key}
            onClick={() => setFilter(f.key)}
          />
        ))}
      </div>

      {state.loading ? (
        <Centered>
          <Spinner />
        </Centered>
      ) : state.error ? (
        <Centered>
          <p className="error">{state.error}</p>
          <p className="hint">
            백엔드가 실행 중인지, 서버 주소 설정(VITE_API_BASE_URL)을 확인하세요.
          </p>
        </Centered>
      ) : signals.length === 0 ? (
        <Centered>
          <p className="hint">해당 신호가 없습니다.</p>
        </Centered>
      ) : (
        <div className="card-list">
          {signals.map((s) => (
            <SignalCard key={s.symbol} signal={s} />
          ))}
        </div>
      )}
    </>
  );
}
